import { useLingui } from '@lingui/react/macro';
import { APP_PATHS } from 'app-shared/constants';
import { IconArrowLeft } from 'app-ui/icon';

import { SETTINGS_NAVIGATION_SECTIONS } from '@/navigation/constants/SettingsNavigationSections';
import { NavigationDrawerItem } from '@/ui/layout/navigation-drawer/components/NavigationDrawerItem';
import { NavigationDrawerSection } from '@/ui/layout/navigation-drawer/components/NavigationDrawerSection';

export const SettingsNavigation = () => {
  const { t, i18n } = useLingui();

  return (
    <>
      <NavigationDrawerSection>
        <NavigationDrawerItem
          label={t`Exit settings`}
          Icon={IconArrowLeft}
          to={APP_PATHS.home}
          end
        />
      </NavigationDrawerSection>
      {SETTINGS_NAVIGATION_SECTIONS.map((navigationSection) => (
        <NavigationDrawerSection
          key={navigationSection.id}
          title={i18n._(navigationSection.title)}
        >
          {navigationSection.items.map((navigationItem) => (
            <NavigationDrawerItem
              key={navigationItem.id}
              label={i18n._(navigationItem.label)}
              Icon={navigationItem.Icon}
              to={navigationItem.path}
            />
          ))}
        </NavigationDrawerSection>
      ))}
    </>
  );
};
